const swea = require('swea');
import * as globals from '../globals';
const ViewerManager = swea.editor.ViewerManager;
const InteractionManager = swea.editor.InteractionManager;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const ContextMenuStateServiceActions = swea.react.actions.ContextMenuStateServiceActions;

class CustomPlaceModelInteraction extends swea.editor.interactions.PlaceModelInteraction {
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }

  whenInitialized(element, viewerId){
    viewerId;
    // Set the correct cursor for the interaction.
    ViewerManager.instance().getViewerById(viewerId).setCursor('crosshair');
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
  }

  whenTerminated(element, viewerId){
    viewerId;
    // Set the correct cursor for the interaction.
    ViewerManager.instance().getViewerById(viewerId).setCursor('default');
    InstructionServiceActions.hideInstruction();
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    
    // Close context menu
    ContextMenuStateServiceActions.closeContextMenu(
      globals.LOWER_CONTEXT_MENU,
    );
  }
}
export default CustomPlaceModelInteraction;
